const sectionSelector = '.why-choose-usrec-section:not(.is-static)';

const EDGE_THRESHOLD = 2;
const WHEEL_SCROLL_SPEED = 0.5;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const pointIsInside = (element, x, y) => {
    const rect = element.getBoundingClientRect();

    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
};

const normalizeWheelDelta = (event, element) => {
    if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) return event.deltaY * 16;
    if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) return event.deltaY * element.clientHeight;

    return event.deltaY;
};

const sectionCallBack = (sectionElement, query, queryAll) => {
    const wrapper = query('.wcu-list-wrapper');
    const scrollElement = query('.wcu-list-scroll');
    const items = queryAll('.wcu-item');

    if (!wrapper || !scrollElement || !items.length) return;
    if (wrapper.dataset.wcuInitialized === 'true') return;

    wrapper.dataset.wcuInitialized = 'true';

    let updateFrame = null;
    const releasePageScrollAtEdges = wrapper.dataset.wcuReleasePageScroll !== 'false';

    wrapper.classList.toggle('is-page-scroll-release', releasePageScrollAtEdges);

    const getMaxScroll = () => Math.max(scrollElement.scrollHeight - scrollElement.clientHeight, 0);

    const setActiveItem = (atStart, atEnd, maxScroll, scrollTop) => {
        let activeIndex = 0;

        if (atStart) {
            activeIndex = 0;
        } else if (atEnd) {
            activeIndex = items.length - 1;
        } else {
            const scrollSegment = maxScroll / Math.max(items.length - 1, 1);
            activeIndex = Math.round(scrollTop / scrollSegment);
        }

        items.forEach((item) => {
            item.classList.toggle('is-active', item === items[activeIndex]);
        });
    };

    const updateState = () => {
        updateFrame = null;

        const maxScroll = getMaxScroll();
        const scrollTop = scrollElement.scrollTop;
        const isScrollable = maxScroll > EDGE_THRESHOLD;
        const atStart = !isScrollable || scrollTop <= EDGE_THRESHOLD;
        const atEnd = !isScrollable || scrollTop >= maxScroll - EDGE_THRESHOLD;

        wrapper.classList.add('is-enhanced');
        wrapper.classList.toggle('is-scrollable', isScrollable);
        wrapper.classList.toggle('is-at-start', atStart);
        wrapper.classList.toggle('is-at-end', atEnd);
        wrapper.classList.toggle('is-between', isScrollable && !atStart && !atEnd);
        wrapper.classList.toggle('has-top-overflow', isScrollable && !atStart);
        wrapper.classList.toggle('has-bottom-overflow', isScrollable && !atEnd);

        setActiveItem(atStart, atEnd, maxScroll, scrollTop);
    };

    const requestStateUpdate = () => {
        if (updateFrame) return;

        updateFrame = requestAnimationFrame(updateState);
    };

    const onWheel = (event) => {
        if (
            event.defaultPrevented
            || event.ctrlKey
            || Math.abs(event.deltaY) <= Math.abs(event.deltaX)
            || !pointIsInside(wrapper, event.clientX, event.clientY)
        ) {
            return;
        }

        const maxScroll = getMaxScroll();
        if (maxScroll <= EDGE_THRESHOLD) return;

        const pageDeltaY = normalizeWheelDelta(event, scrollElement);
        const scaledDeltaY = pageDeltaY * WHEEL_SCROLL_SPEED;
        const maxWheelStep = Math.max(60, maxScroll / Math.max(items.length - 1, 1));
        const deltaY = clamp(scaledDeltaY, maxWheelStep * -1, maxWheelStep);
        const currentScroll = scrollElement.scrollTop;
        const nextScroll = clamp(currentScroll + deltaY, 0, maxScroll);
        const isScrollingPastStart = currentScroll <= EDGE_THRESHOLD && deltaY < 0;
        const isScrollingPastEnd = currentScroll >= maxScroll - EDGE_THRESHOLD && deltaY > 0;

        if (releasePageScrollAtEdges && (isScrollingPastStart || isScrollingPastEnd)) {
            event.preventDefault();
            window.scrollBy({ top: pageDeltaY, behavior: 'auto' });
            requestStateUpdate();
            return;
        }

        if (Math.abs(nextScroll - currentScroll) <= 0.5) {
            event.preventDefault();
            requestStateUpdate();
            return;
        }

        event.preventDefault();
        scrollElement.scrollTop = nextScroll;
        requestStateUpdate();
    };

    scrollElement.addEventListener('scroll', requestStateUpdate, { passive: true });
    window.addEventListener('wheel', onWheel, { capture: true, passive: false });
    window.addEventListener('resize', requestStateUpdate, { passive: true });
    window.addEventListener('load', requestStateUpdate, { once: true });

    requestStateUpdate();
};

export { sectionSelector, sectionCallBack };
